define(
    'modules/image-sorter',[
        'jquery',
        'settings',
        'utils/toast',
        'utils/translate',
        'connections/product-connection'
    ],
    function ($, settings, toast, t, ProductConnection) {
        var ImageSort = (function () {
            function ImageSort() {
                //window.imagesort = this;

                //Object that holds the ajax respins for product images
                this.productImgData = {};

                // Array that holds non product images (environment images)
                this.envImgData = [];

                // Array that holds the image with specific color
                this.thatProductImageSet = [];
            }

            ImageSort.prototype.thatProductImageSetFAllback = [{
                    src: settings.productImageFallbackUrl,
                    alt: t('No image available')
                }];

            /**
             * Sort images so front image is first in the array
             *
             * @method sortImage
             * @param color
             */
            ImageSort.prototype.sortImage = function (color) {
                var _this = this,
                    dataImg = this.productImgData,
                    dataEnvImg = this.envImgData,
                    clickColor,
                    theCopy = [],
                    imgIndx,
                    imges = [];

                if ( $.type( color ) !== "string" ) {
                    clickColor = color.toString();
                } else {
                    clickColor = color;
                }

                // Get the first color as fallback
                if (dataImg.color) {
                    if ( clickColor === "fallback") {
                        clickColor = dataImg.color[0].colorName.toLowerCase();
                    }

                    for (var i = 0; i < dataImg.color.length; i++) {
                        if ( dataImg.color[i].colorCode === clickColor ) {
                            imgIndx = i;
                        }
                    }

                    if (dataImg.color[imgIndx] !== undefined) {
                        $.each(dataImg.color[imgIndx].images, function( index, value ) {
                                theCopy.push(value);
                        });
                        imges = $.merge([],theCopy);
                    }
                }

                if ( imges.length > 0 && imges[0] !== null ) {
                    for (var i2 = 0; i2 < imges.length; i2++) {
                        this.thatProductImageSet.push(imges[i2]);
                    }
                    this.setDefinedImg(0);

                    // Add the env images if the user has chosen a color/variation
                    if( color !== '' ){
                        for (var j = 0; j < dataEnvImg.length; j++) {
                            this.thatProductImageSet.push(dataEnvImg[j]);
                        }
                    }
                } else {
                    // Use the defult images array, only set the definedImg aka big image
                    this.thatProductImageSet.definedImg = [];
                    this.thatProductImageSet.definedImg.src = _this.thatProductImageSetFAllback[0].src;
                    this.thatProductImageSet.definedImg.alt = _this.thatProductImageSetFAllback[0].alt;
                }
            };

            /**
             * Clear the image array
             *
             * @method clearImg
             */

            ImageSort.prototype.clearImg = function () {
                this.thatProductImageSet.splice(0, this.thatProductImageSet.length);
            };

            /**
             * Clears the image array and get the images with color
             *
             * @method loadImg
             * @param color
             */
            ImageSort.prototype.loadImg = function (color) {
                var _this = this,
               clickColor = color;

                // Empty the images array
                this.clearImg();

                // Sort images with the selected color
                this.sortImage(clickColor);

                // TODO: set some kind of defult image if no image/color is matched
            };

            ImageSort.prototype.nullProp = function (obj) {
                  obj.alt = undefined;
                  obj.src = undefined;
                obj.hiDefSrc = undefined;
                return;
            };

            /**
             * Sawp the x and y index in the imagearray
             *
             * @method swap
             * @param x and y
             */
            ImageSort.prototype.swap = function (x,y) {
                var _this = this,
                     tmpY = $.extend({}, this.thatProductImageSet[y]),
                     tmpX = $.extend({}, this.thatProductImageSet[x]);

                if (x === y || isNaN(x) || isNaN(y) ) {
                    // Doesn't need to reindex the image if it's the same or not a number
                    return;
                }

                this.nullProp(this.thatProductImageSet[x]);
                this.nullProp(this.thatProductImageSet[y]);
                // Needs to loop through prop for rivets to update
                for (var prop in tmpY) {
                    _this.thatProductImageSet[x][prop] = tmpY[prop];
                }
                for (var prop2 in tmpX) {
                    _this.thatProductImageSet[y][prop] = tmpX[prop2];
                }
            };

            /**
             * Set x (int) as the bigImage
             *
             * @method swap
             * @param x
             */
            ImageSort.prototype.setDefinedImg = function (x) {
                var _this = this;
                if (isNaN(x)) {
                    return;
                }
                if (this.thatProductImageSet[x] !== null && this.thatProductImageSet[x] !== undefined) {
                    this.thatProductImageSet.definedImg = [];
                    this.thatProductImageSet.definedImg.src = this.thatProductImageSet[x].src;
                    this.thatProductImageSet.definedImg.alt = this.thatProductImageSet[x].alt;
                    this.thatProductImageSet.definedImg.hiDefSrc = this.thatProductImageSet[x].hiDefSrc;
                    this.thatProductImageSet.definedImg.dlImgUrl = this.thatProductImageSet[x].downloadUrl;
                }
            };

            /**
             * Load the images from product ID
             *
             * @method loadProductImages
             * @param id
             * @return {Promise}
             */
            ImageSort.prototype.loadProductImages = function (id, startColor, setZoomImg) {
                var _this = this;

                // TODO Load the appropriate product id
                
                promise = ProductConnection.getProductImages(id).then(function(data) {
                    // TODO Add some fallback if we don't receive any color data
                    if (data.color.length > 0) {
                        _this.productImgData = data;
                        for (var i = 0; i < data.color[0].images.length; i++){
                            if(data.color[0].images[i].isProductImage === false){
                                _this.envImgData.push(data.color[0].images[i]);
                            }
                        }
                        if (startColor !== undefined && startColor !== '') {
                            _this.loadImg(startColor);
                        }else {
                            _this.loadImg(data.color[0].colorCode);
                        }
                    }

                    if(setZoomImg){
                        setZoomImg();
                    }
                });

                promise.fail(function() {
                    if (loadfallbackimg === "fallback") {
                        _this.loadImg("fallback");
                    }

                    toast.queueError(t('Failed to load product image'));
                });

                return promise;
            };

            return ImageSort;
        })();

        return ImageSort;
    }
);

